import { render, staticRenderFns } from "./ConfirmDeletePostsBV.vue?vue&type=template&id=617caa36&scoped=true&"
import script from "./ConfirmDeletePostsBV.vue?vue&type=script&lang=js&"
export * from "./ConfirmDeletePostsBV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617caa36",
  null
  
)

export default component.exports